import { HttpService } from "../http/HttpService";
import { UserBonusEvent, UserBonusEventListRequest, UserBonusEventListResponse } from "../http/protocol";
import { AbstractAdminEntityService } from "./AbstractAdminEntityService";



export class UserBonusEventService extends AbstractAdminEntityService<UserBonusEvent,UserBonusEventListResponse>{
    constructor(http : HttpService) {
        super("/user/bonus", http)
    }

    listUserBonusEvent(request: UserBonusEventListRequest): Promise<UserBonusEventListResponse> {
        return this.http.post(this.entityPath + "/user-bonus/event-list/", request);
    }
}